import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Modal, Grid, Typography, IconButton, Button } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";

const ConfirmationModal = ({
  confirmModal,
  setConfirmModal,
  confirmDisplay,
  setConfirmDisplay,
  setOkCLick,
  selectedFunction,
}) => {
  function getModalStyle() {
    const top = 50;
    const left = 50;

    return {
      top: `${top}%`,
      left: `${left}%`,
      transform: `translate(-${top}%, -${left}%)`,
    };
  }

  const useStyles = makeStyles((theme) => ({
    paper: {
      position: "absolute",
      width: 600,
      backgroundColor: "#F7F6F6",
      border: "0px solid #000",
      boxShadow: theme.shadows[5],
    },
    modalHeader: {
      backgroundColor: theme.palette.primary.dark,
      paddingRight: theme.spacing(2),
      paddingLeft: theme.spacing(2),
    },
    modalBody: {
      padding: theme.spacing(2),
    },
    headerText: {
      color: theme.palette.primary.contrastText,
    },
    button: {
      width: 75,
    },
  }));

  const classes = useStyles();
  // getModalStyle is not a pure function, roll the style only on the first render
  const [modalStyle] = useState(getModalStyle);

  const handleClose = () => {
    setConfirmModal(false);
    setConfirmDisplay("");
  };

  const onOK = () => {
    setConfirmModal(false);
    setConfirmDisplay("");
    setOkCLick(selectedFunction);
  };

  return (
    <Modal
      open={confirmModal}
      onClose={handleClose}
      aria-labelledby="modal-title"
      aria-describedby="modal-description"
    >
      <div style={modalStyle} className={classes.paper}>
        <Grid
          container
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          className={classes.modalHeader}
        >
          <Grid item>
            <Typography variant="h6" className={classes.headerText}>
              <strong> Are you sure ? </strong>{" "}
            </Typography>{" "}
          </Grid>{" "}
          <Grid item>
            <IconButton aria-label="expand row" onClick={handleClose}>
              <CloseIcon
                style={{
                  color: "#ffffff",
                }}
              />{" "}
            </IconButton>{" "}
          </Grid>{" "}
        </Grid>
        {confirmDisplay ? (
          <Grid
            container
            direction="column"
            className={classes.modalBody}
            spacing={1}
          >
            {confirmDisplay.map((each) => (
              <Grid item>
                <Typography variant="body2">
                  <strong> {each.label}: </strong> {each.value}{" "}
                </Typography>{" "}
              </Grid>
            ))}{" "}
          </Grid>
        ) : null}
        <Grid
          container
          direction="row"
          justifyContent="flex-end"
          className={classes.modalBody}
        >
          <Grid item> </Grid>{" "}
          <Button
            onClick={handleClose}
            color="primary"
            className={classes.button}
          >
            CANCEL{" "}
          </Button>{" "}
          <Button onClick={onOK} color="primary" className={classes.button}>
            OK{" "}
          </Button>{" "}
        </Grid>{" "}
      </div>{" "}
    </Modal>
  );
};

export default ConfirmationModal;
